import React, {useState} from "react";
import Button from "../../Common/Button";
import {useDispatch, useSelector} from "react-redux";
import {closeDialog} from "../../../slices/dialog";
import {selectUser} from "../../../slices/profile";
import {CompanyInterface} from "../../../db/models/company/company";
import {makeStyles, MobileStepper} from "@material-ui/core";
import {Cookies} from "react-cookie-consent";
import {useTranslation} from "react-i18next";

export const CompanyWelcome = () => {
    const dispatch = useDispatch();
    const user: CompanyInterface | undefined = useSelector(selectUser);
    const [activeStep, setActiveStep] = useState(0);
    const maxSteps = 2;
    const {t} = useTranslation();

    // const onMoveOn = () => {
    //     dispatch(openDialog({
    //         Content: EditInterests,
    //         title: "Scegli uno o più interessi",
    //         props: { onDialogClose },
    //         closable: false
    //     }));
    // };

    const next = () => {
        // if last step close dialog and save tutorial as done, else go on
        if (activeStep === maxSteps - 1) {
            // highlight rm button of the Vivaio with orange background
            const elem = document.getElementById("cardArea__rmButton");
            if (elem) {
                elem.style.backgroundColor = "#FF8B00";
            }

            // save that this tutorial was done
            Cookies.set("areasTutorialDone", true, {expires: 1000});

            // close dialog
            dispatch(closeDialog());
            return;
        } else {
            setActiveStep(activeStep + 1);
        }
    };

    const back = () => {
        setActiveStep(activeStep - 1);
    };

    const useStyles = makeStyles({
        root: {
            flexGrow: 1,
        },
    });

    const classes = useStyles();

    return (
        <div className="companyWelcome">
            {activeStep === 0 && (
                <>
                    <h2 className="header mb10">{t("company_tutorial_vivaio1_title", {name: user?.name})}</h2>
                    <p className="default mb20">
                        {t("company_tutorial_vivaio1_text")}<br/>
                        <strong>{t("company_tutorial_vivaio1_area_label")}</strong>{" = " + t("company_tutorial_vivaio1_area_def")}<br/>
                        <strong>{t("company_tutorial_vivaio1_path_label")}</strong>{" = " + t("company_tutorial_vivaio1_path_def")}
                    </p>
                </>
            )}
            {activeStep === 1 && (
                <>
                    <h2 className="header mb10">{t("company_tutorial_vivaio2_title")}</h2>
                    <p className="default mb20">
                        {t("company_tutorial_vivaio2_text")}
                    </p>
                </>
            )}

            <MobileStepper
                variant="dots"
                steps={maxSteps}
                position="static"
                activeStep={activeStep}
                className={classes.root}
                nextButton={<Button onClick={next}>{t("company_tutorial_vivaio_nextBtn")}</Button>}
                backButton={
                    <Button onClick={back} disabled={activeStep === 0}>
                        {t("company_tutorial_vivaio_backBtn")}
                    </Button>
                }
            />
        </div>
    );
};
